let contentObj = {}

if (typeof window === 'object') {
  const initI18n = require('@/lang')
  const i18n = initI18n.getI18n()

  /* 路由 */
  const routes = [
    {
      path: '/',
      name: 'Home',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        label: i18n.t('alarmCenter')
      },
      component: () => import('@/views/dataCenter/dataCenter')
    }
  ]
  contentObj = {
    routes
  }
}
const componentsContent = {
  /* 指挥调度页面 */
  'map-of-china': 'map-of-china_tiantong',
  quantityPieChart: 'quantityPieChart_tiantong',
  dataCenter: 'dataCenter_v3_tiantong',
  leftData: 'leftData_v3_tiantong',
  sevenDayData: 'sevenDayData_v3_tiantong',
  titleCpns: 'titleCpns_v3_tiantong',
  userData: 'userData_v3_tiantong',
  fileData: 'fileData_v3_tiantong',
  deviceInfoMapDialog: 'deviceInfoMapDialog_tiantong',
  multipleControlSide: 'multipleControlSide_tiantong'
}
/* 组件样式 */
const componentsStyle = {}
const assetsUrl = 'src/assets/tiantong'

module.exports = {
  ...contentObj,
  assetsUrl,
  componentsContent,
  componentsStyle
}
